import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { API_BASE } from '../utils/api';

const ModalDeletarUsuario = ({ show, onHide, edit, setUsuarios, isDemo }) => {
  const { token } = useAuth();
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const excluir = async () => {
    setErro('');
    setLoading(true);
    if (isDemo) {
      setUsuarios(prev => prev.filter(u => u.id !== edit.id));
      setLoading(false);
      onHide();
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/users/${edit.id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.ok) {
        setUsuarios(prev => prev.filter(u => u.id !== edit.id));
        onHide();
      } else {
        const result = await res.json();
        setErro(result.message || 'Erro ao excluir usuário.');
      }
    } catch (err) {
      setErro('Erro ao conectar com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  if (!edit) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="text-danger">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>Confirmar Exclusão
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {erro && <Alert variant="danger" className="border-0 mb-3">{erro}</Alert>}
        <p>Tem certeza que deseja excluir o membro <strong>{edit.nome}</strong>?</p>
        <p className="text-muted small">Esta ação não poderá ser desfeita.</p>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="light" onClick={onHide}>Cancelar</Button>
        <Button variant="danger" onClick={excluir} disabled={loading}>
          {loading
            ? <><span className="spinner-border spinner-border-sm me-2" />Excluindo...</>
            : <><i className="bi bi-trash me-2"></i>Excluir permanentemente</>}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDeletarUsuario;